import { render, staticRenderFns } from "./ItemInfoRow.vue?vue&type=template&id=0af5ae14&scoped=true"
import script from "./ItemInfoRow.vue?vue&type=script&lang=js"
export * from "./ItemInfoRow.vue?vue&type=script&lang=js"
import style0 from "./ItemInfoRow.vue?vue&type=style&index=0&id=0af5ae14&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af5ae14",
  null
  
)

export default component.exports